import { Agency, AgencyCategory, AgencyCode, AgencyId, Jog, JogId } from ".";
import { WspAgencyLabel, WspDistrictAgencyId } from "./wsp";

const makeAgency = (jogId: JogId, id: AgencyId, name: string, shortName: string, category: AgencyCategory, isFilter = false, isUserAgency = true): Agency => {
  return {
    shortName,
    category,
    id,
    name,
    jogId,
    isUserAgency,
    isFilter
  } as Agency;
}

const notIsUserAgency = false;
const isFilter = true;
const notIsFilter = !isFilter;

// Agencies that exist in multiple JOGs are defined here for easy maintainance. And readability; when you see these added to the Agencies array, you know they are in multiple JOGs.
// When an agency is in multiple JOGs, they need to be added to the array multiple times, once for each JogId, so that the JOG filteres and user invite and edit UIs work correctly.
const kingCountyMetro = makeAgency(JogId.SeattleArea, AgencyCode.KCM, "King County Metro", "King Co. Metro", AgencyCategory.PublicTransit, isFilter);
const soundTransitAgency = makeAgency(JogId.SeattleArea, AgencyCode.SoundTransit, "Sound Transit", "Sound Transit", AgencyCategory.PublicTransit);
const wsdotAgency = makeAgency(JogId.Other, AgencyCode.WSDOT, "Washington State Dept. of Transportation", AgencyCode.WSDOT, AgencyCategory.DOT);
const wspAgency = makeAgency(JogId.Other, AgencyCode.WSP, "Washington State Patrol", AgencyCode.WSP, AgencyCategory.LawEnforcement);

const Agencies: Agency[] = [];

// Other/Statewide
Agencies.push(...[
  makeAgency(JogId.Other, AgencyCode.NWSA, AgencyCode.NWSA, AgencyCode.NWSA, AgencyCategory.Other, notIsFilter),
  { ...wspAgency, jogId: JogId.Other, isUserAgency: true },
  { ...wsdotAgency, jogId: JogId.Other, isUserAgency: true },
]);

// Clark County
Agencies.push(...[
  makeAgency(JogId.ClarkCounty, WspDistrictAgencyId.VAN_D5, "Washington State Patrol (District 5)", WspAgencyLabel.SW_D5, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.ClarkCounty },
  { ...wspAgency, jogId: JogId.ClarkCounty },
]);

// Cowlitz County
// Agencies.push(...[
//   makeAgency(JogId.CowlitzCounty, WspDistrictAgencyId.VAN_D5, "Washington State Patrol (District 5)", WspAgencyLabel.SW_D5, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
//   { ...wsdotAgency, jogId: JogId.CowlitzCounty },
//   { ...wspAgency, jogId: JogId.CowlitzCounty },
// ]);

// Eastern WA Group
// todo: jcavner: Create reusable variables for these, like wspAgency?
Agencies.push(...[
  makeAgency(JogId.EasternWashington, WspDistrictAgencyId.YAK_D3, "Washington State Patrol (District 3)", WspAgencyLabel.YAK_D3, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.EasternWashington, WspDistrictAgencyId.SPO_D4, "Washington State Patrol (District 4)", WspAgencyLabel.SPO_D4, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.EasternWashington, WspDistrictAgencyId.WEN_D6, "Washington State Patrol (District 6)", WspAgencyLabel.WEN_D6, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.EasternWashington },
  { ...wspAgency, jogId: JogId.EasternWashington },
]);

// JBLM
Agencies.push(...[
  makeAgency(JogId.JBLM, WspDistrictAgencyId.TAC_D1, "Washington State Patrol (District 1)", WspAgencyLabel.TAC_D1, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.JBLM },
  { ...wspAgency, jogId: JogId.JBLM },
]);

// Kitsap Peninsula
Agencies.push(...[
  makeAgency(JogId.KitsapPeninsula, WspDistrictAgencyId.PEN_D8, "Washington State Patrol (District 8)", WspAgencyLabel.PEN_D8, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.KitsapPeninsula },
  { ...wspAgency, jogId: JogId.KitsapPeninsula },
]);

// Lewis County
// Agencies.push(...[
//   makeAgency(JogId.LewisCounty, WspDistrictAgencyId.VAN_D5, "Washington State Patrol (District 5)", WspAgencyLabel.SW_D5, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
//   { ...wsdotAgency, jogId: JogId.LewisCounty },
//   { ...wspAgency, jogId: JogId.LewisCounty },
// ]);

// Lower Columbia River
Agencies.push(...[
  makeAgency(JogId.LowerColumbiaRiver, WspDistrictAgencyId.VAN_D5, "Washington State Patrol (District 5)", WspAgencyLabel.SW_D5, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.LowerColumbiaRiver, WspDistrictAgencyId.PEN_D8, "Washington State Patrol (District 8)", WspAgencyLabel.PEN_D8, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.LowerColumbiaRiver },
  { ...wspAgency, jogId: JogId.LowerColumbiaRiver },
]);

// Northwest Washington
Agencies.push(...[
  makeAgency(JogId.NorthwestWashington, WspDistrictAgencyId.NW_D7, "Washington State Patrol (District 7)", WspAgencyLabel.NW_D7, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.NorthwestWashington },
  { ...wspAgency, jogId: JogId.NorthwestWashington },
]);

// Seattle (SAJOG)
Agencies.push(...[
  { ...kingCountyMetro, jogId: JogId.SeattleArea },
  makeAgency(JogId.SeattleArea, AgencyCode.Port, "Port of Seattle", "Port of Sea", AgencyCategory.Other),
  makeAgency(JogId.SeattleArea, AgencyCode.SDOT, "Seattle Dept. of Transportation", "Seattle DOT", AgencyCategory.DOT),
  makeAgency(JogId.SeattleArea, AgencyCode.SFD, "Seattle Fire Dept.", "Seattle FD", AgencyCategory.Fire, isFilter),
  makeAgency(JogId.SeattleArea, AgencyCode.SPD, "Seattle Police Dept.", "Seattle PD", AgencyCategory.LawEnforcement, isFilter),
  makeAgency(JogId.SeattleArea, WspDistrictAgencyId.SEA_D2, "Washington State Patrol (District 2)", WspAgencyLabel.SEA_D2, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...soundTransitAgency, jogId: JogId.SeattleArea },
  { ...wsdotAgency, jogId: JogId.SeattleArea },
  { ...wspAgency, jogId: JogId.SeattleArea },
]);

// NE King County JOG (NEJOG)
Agencies.push(...[
  { ...kingCountyMetro, jogId: JogId.KingCountyNortheast },
  { ...soundTransitAgency, jogId: JogId.KingCountyNortheast },
  { ...wsdotAgency, jogId: JogId.KingCountyNortheast },
  { ...wspAgency, jogId: JogId.KingCountyNortheast },

  // Bellevue
  makeAgency(JogId.KingCountyNortheast, AgencyCode.BellevueFire, "Bellevue Fire Dept.", "Bellevue FD", AgencyCategory.Fire),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.BellevueDot, "Bellevue Dept. of Transportation", "Bellevue DOT", AgencyCategory.DOT),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.BellevuePolice, "Bellevue Police Dept.", "Bellevue PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.CityOfBellevue, "City of Bellevue", "Bellevue", AgencyCategory.Other),

  // Bothell
  makeAgency(JogId.KingCountyNortheast, AgencyCode.BothellEmergencyMgmt, "Bothell Emergency Management", "Bothell EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.BothellPolice, "Bothell Police Dept.", "Bothell PD", AgencyCategory.LawEnforcement),

  makeAgency(JogId.KingCountyNortheast, AgencyCode.EastsideFire, "Eastside Fire", "Eastside Fire", AgencyCategory.Fire),

  makeAgency(JogId.KingCountyNortheast, AgencyCode.FallCityFire, "Fall City Fire", "Fall City FD", AgencyCategory.Fire),

  makeAgency(JogId.KingCountyNortheast, AgencyCode.IssaquahFire, "Issaquah Fire Dept.", "Issa. FD", AgencyCategory.Fire),

  makeAgency(JogId.KingCountyNortheast, AgencyCode.KingCountyEmergencyMgmt, "King County Emergency Management", "KingCo EM", AgencyCategory.EmergencyMgmt),

  // Kirkland
  makeAgency(JogId.KingCountyNortheast, AgencyCode.KirklandFire, "Kirkland Fire Dept", "Kirk. FD", AgencyCategory.Fire),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.KirklandPublicWorks, "Kirkland Public Works", "Kirk. PW", AgencyCategory.PublicWorks),

  // Medina
  makeAgency(JogId.KingCountyNortheast, AgencyCode.MedinaPolice, "Medina Police Dept.", "Medina PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.MedinaPublicWorks, "Medina Public Works", "Medina PW", AgencyCategory.PublicWorks),

  // Mercer Island
  makeAgency(JogId.KingCountyNortheast, AgencyCode.MercerIslandPolice, "Mercer Island Police Dept.", "MI PD", AgencyCategory.LawEnforcement),

  // Newcastle
  makeAgency(JogId.KingCountyNortheast, AgencyCode.CityOfNewcastle, "City of Newcastle", "Newcastle", AgencyCategory.Other),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.NewcastlePublicWorks, "Newcastle Public Works", "Newcastle PW", AgencyCategory.PublicWorks),

  // NORCOM
  makeAgency(JogId.KingCountyNortheast, AgencyCode.Norcom, "NORCOM", "NORCOM", AgencyCategory.EmergencyMgmt),

  // Redmond
  makeAgency(JogId.KingCountyNortheast, AgencyCode.RedmondFire, "Redmond Fire Dept", "Redmond FD", AgencyCategory.Fire),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.RedmondPolice, "Redmond Police Dept", "Redmond PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.RedmondPublicWorks, "Redmond Public Works", "Redmond PW", AgencyCategory.PublicWorks),

  // Shoreline
  makeAgency(JogId.KingCountyNortheast, AgencyCode.ShorelineEmergencyMgmt, "Shoreline Emergency Management", "Shoreline EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountyNortheast, AgencyCode.ShorelineFire, "Shoreline Fire Dept", "Shoreline FD", AgencyCategory.Fire),

  // Snoqualmie
  makeAgency(JogId.KingCountyNortheast, AgencyCode.SnoqualmieFire, "Snoqualmie Fire Dept", "Snoqualmie FD", AgencyCategory.Fire),

  makeAgency(JogId.KingCountyNortheast, WspDistrictAgencyId.SEA_D2, "Washington State Patrol (District 2)", WspAgencyLabel.SEA_D2, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
]);

// South King County JOG (South JOG)
Agencies.push(...[
  makeAgency(JogId.KingCountySouth, AgencyCode.AuburnPolice, "Auburn Police Dept.", "Aburn PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.CityOfSeaTac, "City of SeaTac", "SeaTac", AgencyCategory.Other),
  makeAgency(JogId.KingCountySouth, AgencyCode.CityOfTukwila, "City of Tukwila", "Tukwila", AgencyCategory.Other),
  makeAgency(JogId.KingCountySouth, AgencyCode.CovingtonPolice, "Covington Police Dept.", "Covington PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.DesMoinesPublicWorks, "Des Moines Public Works", "Des Moines PW", AgencyCategory.PublicWorks),
  makeAgency(JogId.KingCountySouth, AgencyCode.DesMoinesPolice, "Des Moines Police Dept", "Des Moines PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.FederalWayEmergencyMgmt, "Federal Way Emergency Mgmt.", "Federal Way EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountySouth, AgencyCode.FederalWayPolice, "Federal Way Police Dept.", "Federal Way PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.FederalWayPublicWorks, "Federal Way Public Works", "Federal Way PW", AgencyCategory.PublicWorks),
  makeAgency(JogId.KingCountySouth, AgencyCode.KentPolice, "Kent Police Dept.", "Kent PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.KingCountyMedicOne, "King County Medic One", "KingCo MedOne", AgencyCategory.Other),
  makeAgency(JogId.KingCountySouth, AgencyCode.KingCountyMedicOne, "King County Emergency Mgmt.", "KingCo EM", AgencyCategory.EmergencyMgmt),
  { ...kingCountyMetro, jogId: JogId.KingCountySouth },
  makeAgency(JogId.KingCountySouth, AgencyCode.MapleValleyPolice, "Maple Valley Police Dept.", "Maple Valley PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.MapleValleyPublicWorks, "Maple Valley Public Works", "Maple Valley PW", AgencyCategory.PublicWorks),
  makeAgency(JogId.KingCountySouth, AgencyCode.MapleValleyEmergencyMgmt, "Maple Valley Emergency Mgmt.", "Maple Valley EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountySouth, AgencyCode.MountainViewFireAndRescue, "Mountain View Fire and Rescue", "Mt. View FR", AgencyCategory.Other),
  makeAgency(JogId.KingCountySouth, AgencyCode.PierceTransit, "Pierce Transit", "Pierce Transit", AgencyCategory.PublicTransit), // Also in Tacoma JOG
  makeAgency(JogId.KingCountySouth, AgencyCode.PugetSoundRegionalFireAuthority, "Puget Sound Regional Fire Authority", "Puget Sound RFA", AgencyCategory.Fire),
  makeAgency(JogId.KingCountySouth, AgencyCode.SeaTacEmergencyManagement, "SeaTac Emergency Mgmt.", "SeaTac EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountySouth, AgencyCode.SeaTacEmergencyManagement, "SeaTac Public Works", "SeaTac PW", AgencyCategory.PublicWorks),
  makeAgency(JogId.KingCountySouth, AgencyCode.TukwilaEmergencyManagement, "Tukwila Emergency Management", "Tukwila EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountySouth, AgencyCode.TukwilaPolice, "Tukwila Police", "Tukwila PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.KingCountySouth, AgencyCode.TukwilaPublicWorks, "Tukwila Public Works", "Tukwila PW", AgencyCategory.PublicWorks),
  makeAgency(JogId.KingCountySouth, AgencyCode.ValleyRegionalFireAuthority, "Valley Regional Fire Authority", "Valley RFA", AgencyCategory.Fire),
  makeAgency(JogId.KingCountySouth, AgencyCode.WaEmergencyMgmtDiv, "Washington Emergency Management Division", "WA EM", AgencyCategory.EmergencyMgmt),
  makeAgency(JogId.KingCountySouth, WspDistrictAgencyId.SEA_D2, "Washington State Patrol (District 2)", WspAgencyLabel.SEA_D2, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...soundTransitAgency, jogId: JogId.KingCountySouth },
  { ...wsdotAgency, jogId: JogId.KingCountySouth },
  { ...wspAgency, jogId: JogId.KingCountySouth },
]);

// Snohomish County JOG
Agencies.push(...[
  makeAgency(JogId.SnohomishCounty, AgencyCode.CityOfSultan, "City of Sultan", "Sultan", AgencyCategory.Other),
  makeAgency(JogId.SnohomishCounty, AgencyCode.CityOfGoldBar, "City of Gold Bar", "Gold Bar", AgencyCategory.Other),
  makeAgency(JogId.SnohomishCounty, AgencyCode.CityOfLakeStevens, "City of Lake Stevens", "Lake Stevens", AgencyCategory.Other),
  makeAgency(JogId.SnohomishCounty, AgencyCode.CityOfMarysville, "City of Marysville", "Marysville", AgencyCategory.Other),
  makeAgency(JogId.SnohomishCounty, AgencyCode.MarysvillePolice, "Marysville Police Dept.", "Marysville PD", AgencyCategory.LawEnforcement),
  makeAgency(JogId.SnohomishCounty, WspDistrictAgencyId.NW_D7, "Washington State Patrol (District 7)", WspAgencyLabel.NW_D7, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...soundTransitAgency, jogId: JogId.SnohomishCounty },
  { ...wsdotAgency, jogId: JogId.SnohomishCounty },
  { ...wspAgency, jogId: JogId.SnohomishCounty },
]);

// Spokane County
Agencies.push(...[
  makeAgency(JogId.Spokane, WspDistrictAgencyId.SPO_D4, "Washington State Patrol (District 4)", WspAgencyLabel.E_D4, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.Spokane },
  { ...wspAgency, jogId: JogId.Spokane },
]);

// Tacoma JOG
Agencies.push(...[
  makeAgency(JogId.Tacoma, WspDistrictAgencyId.TAC_D1, "Washington State Patrol (District 1)", WspAgencyLabel.TAC_D1, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...soundTransitAgency, jogId: JogId.Tacoma },
  { ...wsdotAgency, jogId: JogId.Tacoma },
  { ...wspAgency, jogId: JogId.Tacoma },
]);

// Thurston County JOG
// Agencies.push(...[
//   makeAgency(JogId.ThurstonCounty, WspDistrictAgencyId.WEN_D6, "Washington State Patrol (District 6)", WspAgencyLabel.WEN_D6, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
//   {
//     ...wsdotAgency,
//     jogId: JogId.ThurstonCounty
//   },
//   { ...wspAgency, jogId: JogId.ThurstonCounty },
// ]);

// TriCities JOG
Agencies.push(...[
  makeAgency(JogId.TriCities, WspDistrictAgencyId.YAK_D3, "Washington State Patrol (District 3)", WspAgencyLabel.S_D3, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  { ...wsdotAgency, jogId: JogId.TriCities },
  { ...wspAgency, jogId: JogId.TriCities },
]);

// WSP Districts
Agencies.push(...[
  makeAgency(JogId.Wsp, WspDistrictAgencyId.TAC_D1, "Washington State Patrol (District 1)", WspAgencyLabel.TAC_D1, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.SEA_D2, "Washington State Patrol (District 2)", WspAgencyLabel.SEA_D2, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.YAK_D3, "Washington State Patrol (District 3)", WspAgencyLabel.YAK_D3, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.SPO_D4, "Washington State Patrol (District 4)", WspAgencyLabel.SPO_D4, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.VAN_D5, "Washington State Patrol (District 5)", WspAgencyLabel.VAN_D5, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.WEN_D6, "Washington State Patrol (District 6)", WspAgencyLabel.WEN_D6, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.NW_D7, "Washington State Patrol (District 7)", WspAgencyLabel.NW_D7, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
  makeAgency(JogId.Wsp, WspDistrictAgencyId.PEN_D8, "Washington State Patrol (District 8)", WspAgencyLabel.PEN_D8, AgencyCategory.LawEnforcement, isFilter, notIsUserAgency),
]);

const setAgencyMap = (): Map<AgencyId, Agency> => {
  let agencyMap = new Map<string, Agency>();
  Agencies.forEach((agency) => {
    agencyMap.set(agency.id, agency)
  })

  return agencyMap;
}

// NOTE: If an angecy is "created twice," so it can be put into more than one JOG,
// this map will only have one copy of it, with a reference to only one of the JOGs it's in.
// This could lead to bugs if the agency details are not the same between the copies. Or if 
// this map was used to find out what jog an agency is in.
const AgencyMap = setAgencyMap();

// Used in agency-chip
export const GetAgency = (agencyId: AgencyId) => {
  return AgencyMap.get(agencyId);
}

// Supports pre-JOG existing lists of agencies, before switching to use "Agencies" array.
export const LegacyAgencyGroup: Jog = {
  shortName: "LAG",
  id: JogId.LegacyAgencyGroup,
  name: "Legacy Agency Group",

  // these are in "display order"
  agencies: [
    kingCountyMetro,
    AgencyMap.get(AgencyCode.NWSA),
    AgencyMap.get(AgencyCode.Port),
    AgencyMap.get(AgencyCode.SDOT),
    AgencyMap.get(AgencyCode.SFD),
    AgencyMap.get(AgencyCode.SPD),
    { ...soundTransitAgency },
    { ...wsdotAgency },
    { ...wspAgency },
    AgencyMap.get(AgencyCode.CityOfBellevue),
    AgencyMap.get(AgencyCode.CityOfGoldBar),
    AgencyMap.get(AgencyCode.CityOfSultan),
    AgencyMap.get(AgencyCode.EastsideFire),
    AgencyMap.get(AgencyCode.MedinaPolice),
    AgencyMap.get(AgencyCode.MarysvillePolice),
    AgencyMap.get(AgencyCode.CityOfMarysville),
    AgencyMap.get(AgencyCode.CityOfLakeStevens),
  ]
} as Jog;

export default Agencies;